import { render, staticRenderFns } from "./create-link-dialog.vue?vue&type=template&id=4dbb3240&scoped=true&"
import script from "./create-link-dialog.vue?vue&type=script&lang=ts&"
export * from "./create-link-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./create-link-dialog.vue?vue&type=style&index=0&id=4dbb3240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbb3240",
  null
  
)

export default component.exports